//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var imgUrl = require('@/assets/image/img-time.png');

export default {
  meta: {
    title: '提现申请',
    auth: true,
    authorityValue: "store-transfers-manage"
  },
  name: 'walletSubmit',
  data: function data() {
    return {
      subTitle: '已提交成功，请等待平台审核',
      title: '入驻审核未通过',
      imgUrl: imgUrl
    };
  },
  mounted: function mounted() {},
  methods: {}
};